import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
} from '@angular/core';
import { QueryService } from '@app/core/graphql/query/query.service';
import { NavController } from '@ionic/angular';

@Component({
    selector: 'app-application-chain-list',
    templateUrl: './application-chain-list.component.html',
    styleUrls: ['./application-chain-list.component.scss'],
})
export class ApplicationChainListComponent implements OnChanges {
    @Input() chainedApplications: any[];

    @Output() private onApplicationSelection = new EventEmitter<string>();

    selectedProgram: string;

    constructor(
        private navCtrl: NavController,
        private queryService: QueryService
    ) {}

    ngOnChanges() {
        if (this.chainedApplications && this.chainedApplications.length) {
            this.selectedProgram = this.chainedApplications[0].programid;
        }
    }

    openApplication(id: string): void {
        if (id) {
            this.queryService.applicationChainRouting(id).subscribe(res => {
                const currentApplication = res.data.user.application;

                const query = this.createQuery(currentApplication);

                if (
                    currentApplication.states === 'Pending' ||
                    currentApplication.states === 'Pending-Booked' ||
                    currentApplication.states === 'Pre-Approved' ||
                    currentApplication.states === 'Completed'
                ) {
                    this.navCtrl.navigateRoot([
                        '/application/' + currentApplication.id,
                    ]);
                } else if (currentApplication.requiresPayment) {
                    this.navCtrl.navigateRoot(['/payment/'], {
                        queryParams: query,
                    });
                } else if (
                    (!currentApplication.requiresPayment &&
                        currentApplication.program.requiredpostdocumentlist
                            .requireContract === true &&
                        currentApplication.signedcontract === null) ||
                    (currentApplication.program.requiredpostdocumentlist
                        .default &&
                        !currentApplication.signedcontract)
                ) {
                    this.navCtrl.navigateRoot(
                        [
                            '/application/' +
                                currentApplication.id +
                                '/clinical-agreement',
                        ],
                        { queryParams: query }
                    );
                } else if (
                    currentApplication.program.requiredpostdocumentlist
                        .requireContract === false &&
                    currentApplication.signedcontract === null
                ) {
                    this.navCtrl.navigateRoot(
                        [
                            '/application/' +
                                currentApplication.id +
                                '/clinical-agreement',
                        ],
                        { queryParams: query }
                    );
                } else {
                    this.navCtrl.navigateRoot([
                        '/application/' + currentApplication.id,
                    ]);
                }
            });
        }
    }

    private createQuery(application: any): any {
        const query =
            application.states === 'Pending' ||
            application.states === 'Pending-Booked' ||
            application.states === 'Pre-Approved'
                ? {}
                : !application.requiresPayment && !application.signedcontract
                ? { applicationId: application.id, userId: application.userid }
                : !application.requiresPayment
                ? {}
                : application.madedeposit
                ? { applicationid: application.id, type: 'final-payment' }
                : { applicationid: application.id, type: 'first-payment' };

        return query;
    }

    openProgramDetails(programid: string) {
        if (programid) {
            this.selectedProgram = programid;
            this.onApplicationSelection.emit(programid);
        }
    }
}
